/* istanbul ignore file */
export enum KPContentType {
  PageHeader = 'page_header',
  PageFooter = 'page_footer',
  PDPPage = 'pdp_page',
  PLPPage = 'plp_page',
  Banner = 'banner',
  ProductGrid = 'product_grid',
  ContactsPDPPage = 'contacts_pdp_page',
  Notification = 'notification',
  ProductFeature = 'product_features.features',
  StoreAvailability = 'store_availability',
  OurGuarantees = 'product_features.our_guarantees',
  OpticalBenefits = 'product_features.optical_benefits',
  AnnualSupplyDiscount = 'product_features.annual_supply_discount',
  NavigationLinks = 'navigation_links',
  NavigationToolBarLinks = 'navigation_toolbar_links',
  NavigationMenu = 'navigation_menu',
  MarketingGridContentRow = 'marketing_grid.select_marketing_content_products.content_row.reference',
  MarketingGridTiles = 'marketing_grid.select_marketing_content_products.stack_tiles_horizontal_.reference',
  AboutBrand = 'about_the_brand',
  ProtectionAndSavingsPlan = 'protection_and_savings_plan',
  AccountTab = 'tab',
  BenefitTables = 'benefit_tables',
  BenefitMarketingBlock = 'marketing_block',
  IngredientsList = 'ingredient_list',
  UserAccount = 'user_account',
  OrderHistory = 'order_history.order_history',
  CancelOrder = 'cancel_order',
  Page = 'page',
  ContactUs = 'contact_us',
  ProductDetail = 'product_detail',
  CartPage = 'cart_page',
  ProductFeatures = 'product_features',
  ProductInfo = 'product_info',
  AttributeLabels = 'product_info.attribute_labels',
  FindLocation = 'find_location_page',
  ArticlePage = 'article_page',
  FAQsPage = 'faqs_page',
  FAQsAccordion = 'faqs.faqs_accordion',
  ArticlePageStepByStep = 'articles.step_by_step_guide.guides',
  ArticlePageStepByStepNavigationButtons = 'articles.step_by_step_guide.guides.navigation_buttons.internal.site_map_link',
  ArticlePageNavigationButtons = 'articles.article_sections.navigation_button.navigation_link.site_map_link',
  ArticlePageRebates = 'articles.rebates.guides',
  ArticleContentBanners = 'articles.content_banners.banners',
  ArticleDynamicData = 'articles.article_dynamic_section.dynamic_data',
  ArticleDynamicDataTable = 'articles.article_dynamic_section.dynamic_data.article_dynamic_panel.table_data.basic_table_information',
  ArticleDynamicDataNav = 'articles.article_dynamic_section.dynamic_data.article_dynamic_panel.navigation_button.navigation_link',
  ArticleDynamicDataImg = 'articles.article_dynamic_section.dynamic_data.article_dynamic_panel.image_for_desktop_and_mobile.image_upload',
  LensWizardPage = 'eyeglass_lens_wizard_page',
  LensWizardStep = 'wizard_steps.wizard_step.eyeglass_lens_wizard_step',
  LensWizardOption = 'eyeglass_lens_wizard_option',
  LensWizardCollection = 'eyeglass_lens_wizard_collection',
  LensWizardMessage = 'eyeglass_lens_wizard_message',
  ContactUsTile = 'contact_us_tiles.contact_us_tile',
  ContactUsCardGroup = 'contact_us_tiles.card_group_tiles.card_group',
  ClAttributesNamingMap = 'product_rules.cl_attri_transformations',
  AddFavorite = 'add_favorite',
  ContactsSigninPdp = 'handle_contacts_signin',
}
